import { render, staticRenderFns } from "./jmsServiceRelieveContract.vue?vue&type=template&id=878ad178"
import script from "./jmsServiceRelieveContract.vue?vue&type=script&lang=js"
export * from "./jmsServiceRelieveContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports